import { Controller, useFormContext } from 'react-hook-form';
import _ from 'lodash';
import PhoneInput from 'react-phone-input-2';
import Typhography from '../../Typhography/Typhography';
import { PhoneField } from '../types';

const PhoneFieldForm = ({ field }: { field: PhoneField }) => {
  const {
    control,
    formState: { errors },
    setValue,
    getValues,
  } = useFormContext();
  const currentError = _.get(errors, field.key);
  return (
    <div>
      {field.label && (
        <Typhography size="bold-14" type="span" className="label-input">
          {field.label}
        </Typhography>
      )}
      <Controller
        name={field.key}
        control={control}
        render={({ field: renderField }) => (
          <PhoneInput
            inputClass="w-100"
            country="it"
            disabled={field.disabled as boolean}
            placeholder={field.placeholder}
            value={renderField.value || ''}
            onChange={(phone) => {
              renderField.onChange(phone);
              field.onAfterChange?.(phone, { setValue, getValues });
            }}
          />
        )}
      />
      {currentError && (
        <p className="text-danger" style={{ fontSize: 12 }}>
          {(currentError as any).message}
        </p>
      )}
    </div>
  );
};

export default PhoneFieldForm;
